<template>
  <div class="template_wrapper">
    <!-- <span style="color:red;"  v-if="moduel.required==1">*</span>
        <span class="demonstration">{{moduel.name}}</span>
        <el-input placeholder="请输入内容" v-model="name" @change="textChange" :disabled="disabled">
        </el-input>
    <span v-if="moduel.key_name == 'workday'">天</span>-->
    <div class="template_title">
      <span style="color:red;" v-if="moduel.required==1">*</span>
      {{moduel.name}}
    </div>
    <el-input
      placeholder="请输入内容"
      v-model="content"
      @textChange="change"
      :disabled="disabled"
      :class="{'project_name_key':moduel.name== '项目名称'}"
    ></el-input>
    <span v-if="moduel.key_name == 'workday'">天</span>
    <!-- <span v-if="moduel.required!=1" >选填</span> -->
    <div
      style="width:auto;word-wrap:break-word;position:fixed;left:-10000px;font-size: 17px;line-height:22px;height:22px;"
      ref="computed_content_input"
      v-if="moduel.key_name == 'name'"
      v-html="content"
    ></div>
    <div
      style="width:auto;word-wrap:break-word;position:fixed;left:-10000px;font-size: 14px;line-height:22px;height:22px;"
      ref="computed_content_input"
      v-else
      v-html="content"
    ></div>
  </div>
</template>
<script>
export default {
  name: "inputs",
  data() {
    return {
      content: "",
      len: 10,
      disabled: false,
      inited: false
    };
  },
  props: ["moduel", "projectData", "type", "projectNum", "input_callback"],
  methods: {
    change() {},
    textChange() {
      console.log(this.content);
    }
  },
  beforeDestroy() {},
  created() {},
  mounted() {
    if (this.moduel.key_name == "name" && this.type == "edit") {
      this.content = this.projectNum + " " + this.projectData.name;
      this.disabled = true;
    } else {
      this.disabled = false;
      this.content = this.projectData[this.moduel.key_name];
    }
    var that = this;
    this.$nextTick(function() {
      that.inited = true;
    });
  },
  watch: {
    content: {
      handler(newName, oldName) {
        if (this.inited) {
          var that = this;
          if (!this.disabled) {
            this.$nextTick(function() {
              that.$emit("input", this.content);
              that.$emit("listenToChildEvent", that.type);
              var _content_height =
                that.$refs["computed_content_input"].offsetWidth;
              that.input_callback(that.moduel.key_name, _content_height);
              console.log(_content_height);
            });
          }
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
.project_name_key .el-input__inner {
  color: #00499a !important;
  font-size: 17px;
  font-family: "微软雅黑";
  font-weight: bold;
}
.project_name .el-input__inner::-webkit-input-placeholder {
  font-size: 14px;
  font-weight: normal;
}
.project_name .el-input__inner::-moz-placeholder {
  font-size: 14px;
  font-weight: normal;
}
.project_name .el-input__inner:-ms-input-placeholder {
  font-size: 14px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/c-input.vue